/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from "@ember/component/template-only";
const ProcessLoading = templateOnly();
export default ProcessLoading;
